import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { BRAND } from '../data/mock';

const StickyCTA = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <div className={`lg:hidden fixed bottom-0 inset-x-0 z-30 transition-transform duration-300 ${show ? 'translate-y-0' : 'translate-y-full'}`}>
      <div className="bg-[#F5F3EF]/95 backdrop-blur border-t border-brand-gold/30 px-4 py-3 flex items-center gap-3">
        <a href={`tel:${BRAND.phoneRaw}`} className="flex-1 flex items-center justify-center gap-2 border border-brand-gold/50 text-brand-gold py-3 text-[13px] rounded-sm">
          <Phone size={14} /> Hemen Ara
        </a>
        <Link to="/iletisim" className="flex-1 flex items-center justify-center gap-2 bg-brand-gold text-brand-ink py-3 text-[13px] font-medium rounded-sm">
          Teklif Al <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
};

export default StickyCTA;
